const PERMISSION_KEY= "core:securities_account";
const PAGE_URL = {
    SECURITIES_ACCOUNT_PAGE: "/admin/core/securities-account"
}

export {PERMISSION_KEY, PAGE_URL}

